import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import BrandIntro from "@/components/sections/BrandIntro";
import EventTracks from "@/components/sections/EventTracks";
import WellnessLaunch from "@/components/sections/WellnessLaunch";
import FeaturedEvents from "@/components/sections/FeaturedEvents";
import CorporateEvents from "@/components/sections/CorporateEvents";
import HowItWorks from "@/components/sections/HowItWorks";
import SampleAgenda from "@/components/sections/SampleAgenda";
import Partners from "@/components/sections/Partners";
import Audience from "@/components/sections/Audience";
import CircleForm from "@/components/sections/CircleForm";
import Testimonials from "@/components/sections/Testimonials";
import EnquiryForm from "@/components/sections/EnquiryForm";
import FAQSection from "@/components/sections/FAQSection";
import Footer from "@/components/sections/Footer";
import MobileStickyCTA from "@/components/sections/MobileStickyCTA";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[var(--aura-ivory)] text-[var(--aura-charcoal)]">
      <Header />
      <main id="home">
        <Hero />
        <BrandIntro />
        <EventTracks />
        <WellnessLaunch />
        <FeaturedEvents />
        <CorporateEvents />
        <HowItWorks />
        <SampleAgenda />
        <Partners />
        <Audience />
        <CircleForm />
        <Testimonials />
        <EnquiryForm />
        <FAQSection />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
